import { Button } from "@aircall/ds";
import type { MouseEventHandler } from "react";
import { useTranslation } from "react-i18next";

import { HeaderSimple } from "../../../pages/conversation_center/components/HeaderSimple/HeaderSimple";
import type { CallType } from "../call_type/call_type.constants";
import type { ColumnType } from "../columns.decl";

type RendererProps = {
  callId: number;
  type: CallType;
};

function Renderer(_props: RendererProps) {
  const { t } = useTranslation();

  // dev-only: CC opens a PreviewDrawer here; on the dev page the row click
  // already navigates to the call, so this is a no-op (and the preview column
  // is filtered out of the rendered set in DevHome).
  const handleOnClick: MouseEventHandler<HTMLElement> = (event) => {
    event.stopPropagation();
  };

  return (
    // `opacity-0` is a Tailwind utility (not a styled-components rule) so it
    // shares the @layer utilities cascade with the row-hover reveal in
    // TableContent (`...:opacity-100`); an unlayered styled-components
    // `opacity:0` would always win and the button would never appear on hover.
    <div
      onClick={handleOnClick}
      data-test="table-preview-wrapper"
      className="opacity-0"
    >
      <Button data-test="table-preview-button" variant="ghost" size="sm">
        {t("preview")}
      </Button>
    </div>
  );
}

export const previewConfig: ColumnType = {
  id: "preview",
  label: <HeaderSimple label="" />,
  renderer: ({ callId, type }) => <Renderer callId={callId} type={type} />,
};
